module.exports = __webpack_public_path__ + "img/axonometric.8969f779.png";